import { callWebUtils } from "../../Components/CampaignMembers/helpers";
import { ActionsMediaAssetsLab } from "./ActionsMediaAssetsLab";

export const ActionsListenersMediaAssetsLab = ({ database }) => {
  ActionsMediaAssetsLab.getCloudinaryImages.listen(function (campaignId, defaultCreatives = []) {
    return callWebUtils(this, "getCloudinaryImages", [campaignId]);
  });

  ActionsMediaAssetsLab.getAssetsByCampaignId.listen(function (campaignId, defaultCreatives = []) {
    return callWebUtils(this, "getAssetsByCampaignId", [campaignId]);
  });

  ActionsMediaAssetsLab.updateCloudinaryMetadataCampaignId.listen(function (campaignIds) {
    return callWebUtils(this, "updateCloudinaryMetadataCampaignId", [campaignIds]);
  });
};
